<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <boton-cancelar boton-text="Finalizar" variant="secondary" loading-text="cargando" :loader="loader" @accion="finalizar"></boton-cancelar>
  </div>
</template>

<script>
import BotonCancelar from "@/components/BotonCancelar";

export default {
  name: "BotonFinSolicitud",
  components: {BotonCancelar},
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      loader: false
    }
  },
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  props: {
    data: Object,
  },
  methods:{
    finalizar(){
      this.$http.post(this.$api+'pti/bandeja/embajador/finSolicitud?idSolicitud='+this.data.item.idSolicitudDiagnostico).then(() => {
        this.$emit("_funcionExtra",6);
      })
    }
  }
}
</script>
